import React from 'react';
import { Paragraph } from 'apps/sigma2-ui/src/components/ui/Paragraph';
import { SimpleInput } from 'apps/sigma2-ui/src/components/ui/SimpleInput';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { OnOrganizationSecretCreateCompleteFn } from 'apps/sigma2-ui/src/secrets/lib/types';
import { useOrganizationSecretCreateComponent } from 'apps/sigma2-ui/src/secrets/lib/useOrganizationSecretCreateComponent';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';

export const OrganizationSecretCreateComponent = ({
  organizationId,
  onComplete,
}: {
  organizationId: string;
  onComplete: OnOrganizationSecretCreateCompleteFn;
}) => {
  const {
    createSecretDescription,
    setCreateSecretDescription,
    createSecretValue,
    setCreateSecretValue,
    createSecretTitle,
    createSecretButtonLabel,
    createSecretButtonBehavior,
    createSecretDescriptionLabel,
    createSecretValueLabel,
    createSecretButtonDisabled,
  } = useOrganizationSecretCreateComponent({
    organizationId,
    onComplete,
  });

  return (
    <Spacing size={'md'} direction={'vertical'}>
      <Paragraph>{createSecretTitle}</Paragraph>

      <SimpleInput
        label={createSecretDescriptionLabel}
        value={createSecretDescription}
        onChange={setCreateSecretDescription}
      />

      <SimpleInput
        label={createSecretValueLabel}
        value={createSecretValue}
        onChange={setCreateSecretValue}
        isPassword={true}
      />

      <Button
        behavior={createSecretButtonBehavior}
        text={createSecretButtonLabel}
        disabled={createSecretButtonDisabled}
      />
    </Spacing>
  );
};
